import { css } from 'styled-components'

import { transparentize } from 'polished'

export const Checkbox = css`
  &[type=checkbox] {
    display: none;

    + span {
      display: block;
      margin: 2px;
      cursor: pointer;
      padding: 2px;
      white-space: nowrap;

      &::before {
        content: "\\2714";
        border: 1px solid ${props => props.theme.palette.general.greyDark};
        display: inline-block;
        padding-left: 3px;
        padding-bottom: 3px;
        margin-right: 9px;
        box-sizing: border-box;
        width: 17px;
        height: 17px;
        vertical-align: bottom;
        color: transparent;
        transition: 0.2s;
        position: relative;
        top: 2px;
        padding-top: 2px;
        font-size: 12px;
        border-radius: 3px;
      }

      &:active {
        &::before {
          transform: scale(0.5);
        }
      }

      &:hover {
        &::before {
          border-color: ${props => props.theme.palette.primary.alpha};
        }
      }
    }

    &:checked {
      + span {
        &::before {
          background-color: ${props => props.theme.palette.general.strong};
          border-color: ${props => props.theme.palette.general.strong};
          color: ${props => props.theme.palette.general.light};
          box-shadow: inset 0 1px 3px 0 ${props => transparentize(0.5, props.theme.palette.general.light)};
        }
      }
    }

    &:disabled {
      + span {
        &::before {
          transform: scale(1);
          border-color: ${props => props.theme.palette.general.genericGrey};
        }
      }
    }
  }
`
